/**
 * 브라우저 뒤로가기 방지를 위한 유틸리티 함수들
 */

/**
 * 뒤로가기 방지 초기화 - 히스토리에 현재 상태를 추가하여 뒤로가기 동작을 변경함
 */
export const initPreventBack = () => {
  window.history.pushState(null, document.title, window.location.href);
};

/**
 * 뒤로가기 이벤트를 감지하고 현재 페이지에 머물도록 함
 * @param {string} currentPath - 현재 페이지 경로
 * @param {function} navigate - React Router의 navigate 함수
 * @returns {function} - 이벤트 리스너 제거 함수
 */
export const preventBack = (currentPath, navigate) => {
  const handlePopState = () => {
    // 현재 페이지로 다시 이동 (replace: true로 히스토리 스택에 새 항목을 추가하지 않음)
    navigate(currentPath, { replace: true });
    // 히스토리에 현재 상태를 다시 추가
    window.history.pushState(null, document.title, window.location.href);
  };

  // popstate 이벤트 리스너 등록 (브라우저 뒤로가기 버튼 클릭 감지)
  window.addEventListener("popstate", handlePopState);

  // 제거 함수 반환
  return () => {
    window.removeEventListener("popstate", handlePopState);
  };
};

/**
 * 향상된 페이지 이동 함수 - 히스토리를 대체하여 뒤로가기 방지
 * @param {string} path - 이동할 경로
 * @param {function} navigate - React Router의 navigate 함수
 */
export const navigateWithoutHistory = (path, navigate) => {
  navigate(path, { replace: true });
};
